import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { money } from "./api";

export function exportGroupPDF(group) {
  const doc = new jsPDF();
  const green = [28, 63, 53];
  const terra = [204, 85, 0];

  doc.setFillColor(...green);
  doc.rect(0, 0, 210, 28, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("LUSH OPERATIONS", 14, 13);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Event Arrangement & Quotation", 14, 21);

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(group.name, 14, 40);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  const info = [
    `Contact: ${group.contact_person || "-"}`,
    `Phone: ${group.phone || "-"}   Email: ${group.email || "-"}`,
    `Group Size: ${group.size || 0} pax   Status: ${group.status}`,
    `Event Date: ${group.event_date || "-"}${group.event_end_date ? " to " + group.event_end_date : ""}`,
    `Relationship Manager: ${group.rm_name || "-"}`,
  ];
  info.forEach((line, i) => doc.text(line, 14, 48 + i * 6));

  let y = 84;
  autoTable(doc, {
    startY: y,
    head: [["Package", "Base Price"]],
    body: [[group.package_name || "No package", money(group.package_price || 0)]],
    theme: "grid",
    headStyles: { fillColor: green, textColor: 255 },
    styles: { fontSize: 10 },
  });
  y = doc.lastAutoTable.finalY + 6;

  if (group.add_ons && group.add_ons.length) {
    autoTable(doc, {
      startY: y,
      head: [["Add-on Activity", "Qty", "Unit Price", "Subtotal"]],
      body: group.add_ons.map((a) => [a.name, a.qty, money(a.price), money(a.price * a.qty)]),
      theme: "grid",
      headStyles: { fillColor: terra, textColor: 255 },
      styles: { fontSize: 10 },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  if (group.reservations && group.reservations.length) {
    autoTable(doc, {
      startY: y,
      head: [["Reserved Zone", "Date", "Pax"]],
      body: group.reservations.map((r) => [r.zone_name, r.date, r.pax]),
      theme: "grid",
      headStyles: { fillColor: green, textColor: 255 },
      styles: { fontSize: 10 },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  if (group.scheduled_activities && group.scheduled_activities.length) {
    autoTable(doc, {
      startY: y,
      head: [["Scheduled Activity", "Date", "Time"]],
      body: group.scheduled_activities.map((a) => [a.activity_name, a.date, a.time]),
      theme: "grid",
      headStyles: { fillColor: green, textColor: 255 },
      styles: { fontSize: 10 },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  const total =
    (group.package_price || 0) +
    (group.add_ons || []).reduce((s, a) => s + a.price * a.qty, 0);
  doc.setFillColor(...green);
  doc.rect(120, y, 76, 14, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("TOTAL", 124, y + 9);
  doc.text(money(total), 192, y + 9, { align: "right" });

  doc.save(`LUSH-${group.name.replace(/\s+/g, "-")}-Quote.pdf`);
}

export function exportInvoicePDF(inv) {
  const doc = new jsPDF();
  const green = [28, 63, 53];
  const fmt = (n) => (Number(n) || 0).toLocaleString("en-LK", { maximumFractionDigits: 0 });

  doc.setFillColor(...green);
  doc.rect(0, 0, 210, 30, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("LUSH", 14, 15);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text("Adventure & Events Resort", 14, 22);
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.text("INVOICE", 196, 15, { align: "right" });
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(inv.invoice_no, 196, 23, { align: "right" });

  doc.setTextColor(30, 30, 30);
  doc.setFontSize(10);
  doc.text(`Date: ${inv.date}`, 14, 42);
  doc.setFont("helvetica", "bold");
  doc.text("Billed To:", 14, 50);
  doc.setFont("helvetica", "normal");
  doc.text(inv.client_name || "-", 14, 56);
  if (inv.client_contact) doc.text(inv.client_contact, 14, 62);
  if (inv.created_by) doc.text(`Issued by: ${inv.created_by}`, 196, 42, { align: "right" });

  autoTable(doc, {
    startY: 70,
    head: [["#", "Description", "Qty", "Unit Price (LKR)", "Amount (LKR)"]],
    body: inv.items.map((it, i) => [i + 1, it.description, it.qty, fmt(it.unit_price), fmt(it.amount)]),
    theme: "grid",
    headStyles: { fillColor: green, textColor: 255 },
    styles: { fontSize: 10 },
    columnStyles: { 0: { cellWidth: 10 }, 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
  });

  let y = doc.lastAutoTable.finalY + 8;
  const line = (label, val, bold) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.text(label, 150, y);
    doc.text(val, 196, y, { align: "right" });
    y += 6;
  };
  line("Subtotal", "LKR " + fmt(inv.subtotal));
  if (inv.tax_pct) line(`Tax (${inv.tax_pct}%)`, "LKR " + fmt(inv.tax_amount));
  doc.setFillColor(...green);
  doc.rect(148, y - 4, 50, 9, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text("TOTAL", 150, y + 2);
  doc.text("LKR " + fmt(inv.total), 196, y + 2, { align: "right" });

  if (inv.notes) {
    doc.setTextColor(60, 60, 60);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Notes: ${inv.notes}`, 14, y + 18);
  }
  doc.setTextColor(130, 130, 130);
  doc.setFont("helvetica", "italic");
  doc.setFontSize(9);
  doc.text("This is a computer generated invoice. No signature required.", 105, 288, { align: "center" });
  doc.save(`${inv.invoice_no}.pdf`);
}
